/* eslint-disable no-undef */
import Dialog from '@/ui/dialogs/Dialog'
import { useDialogRef } from '@/utils/dialog'
import styles from './index.module.css'

export const Version = () => {
  const { dialogRef, handleOpen, handleClose } = useDialogRef()

  return (
    <>
      <div className={styles.container} data-screenshots-id="version-button">
        <button className={styles.version} onClick={handleOpen}>
          v{APP_VERSION}
        </button>
      </div>

      <Dialog
        ref={dialogRef}
        title="Software actualizable"
        onClose={handleClose}
        hasVisibleBackground
        dataScreenshotsId="version-modal-content"
      >
        <div>
          <h3 className={styles.subtitle}>Versión {APP_VERSION}</h3>
        </div>
        <div className={styles.content}>
          <p>
            En nuestro compromiso por ofrecerte una herramienta cada vez más
            potente y eficiente, nuestro software está en constante evolución.
            Nos dedicamos a mejorar la funcionalidad, optimizar el rendimiento y
            agregar nuevas características de forma regular.
          </p>
          <p>
            Por esta razón, al adquirir una licencia de nuestro servicio,
            obtienes acceso a todas las futuras actualizaciones que lancemos. Tu
            licencia te garantiza que siempre tendrás acceso a la versión más
            reciente del software, lo que te asegura estar al día con las
            últimas innovaciones, mejoras de seguridad y optimizaciones de
            rendimiento.
          </p>
          <p>
            Actualmente, la versión activa del software es la{' '}
            <strong>{APP_VERSION}</strong>.
          </p>
          <p>
            Nuestro objetivo es que tu inversión en nuestra plataforma sea
            duradera y valiosa, proporcionándote siempre la mejor versión
            posible sin costes adicionales por actualización.
          </p>
        </div>
      </Dialog>
    </>
  )
}
